import {Component, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Modal} from '@softline/ui-core';
import { ReactiveFormsModule } from '@angular/forms';
import { ArtikelInformationen } from '../../types/artikel';
import { BehaviorSubject, Observable, combineLatestWith, map } from 'rxjs';
import { Dictionary } from '@softline/core';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-artikel-hinzufuegen-dialog',
    imports: [CommonModule, ReactiveFormsModule,
    TranslatePipe],
    templateUrl: './artikel-hinzufuegen-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./artikel-hinzufuegen-dialog.component.css']
})
export class ArtikelHinzufuegenDialogComponent implements Modal<ArtikelInformationen[]> {

  close!: (result: ArtikelInformationen[]) => void;

  private readonly weitereArtikel$ = new BehaviorSubject<ArtikelInformationen[]>([]);
  private readonly selected$ = new BehaviorSubject<Dictionary<ArtikelInformationen>>({});

  set weitereArtikel(value: ArtikelInformationen[]) {
    this.weitereArtikel$.next(value);
  }

  readonly artikelWithSelection$: Observable<{ basisartikel: ArtikelInformationen; selected: boolean }[]> = this.weitereArtikel$.pipe(
    combineLatestWith(this.selected$),
    map(([weitereArtikel, selectedMap]) => {
      return weitereArtikel.map(basisartikel => ({
        basisartikel,
        selected: !!selectedMap[basisartikel.artikel.id]
      }))
    })
  );

  constructor() {}

  registerCloseHandler(handler: (result: ArtikelInformationen[]) => void) {
    this.close = handler;
  }

  saveArtikel() {
    this.close(Object.values(this.selected$.value).filter(o => o !== undefined) as ArtikelInformationen[]);
  }

  selectArtikel(basisartikel: ArtikelInformationen) {
    let selectionMap = this.selected$.value;
    const selected = !!selectionMap[basisartikel.artikel.id];

    if (selected) {
      delete selectionMap[basisartikel.artikel.id]
      selectionMap = { ...selectionMap }
    } else {
      selectionMap = { ...selectionMap, [basisartikel.artikel.id]: basisartikel }
    }

    this.selected$.next(selectionMap);
  }
}
